import { createContextualCan } from '@casl/react';
import { AppAbility } from 'configs/types';
import { createContext } from 'react';

export const AbilityContext = createContext<AppAbility>({} as AppAbility);
export const Can = createContextualCan(AbilityContext.Consumer);
